export default __webpack_public_path__ + "static/images/login/background4.703a4d09f997cf24121c7123bcbeb987.png";